export default "__VITE_ASSET__8bc78815__"